<template>
  <div class="general-wrapper">
    <Header />
    <div class="integrations-market gap-row-lg">
      <template v-for="(category, index) in nonEmptyCategories">
        <div class="gap-row-lg" :key="category">
          <div class="gap-row-sm">
            <h3 class="qrw-heading-xs bold pl-40 v1-grey-10-color pr-40">
              {{ $t("integrations_market.categories." + category) }}
            </h3>
            <IQOSHorizontalScroll class="integrations-container">
              <div
                class="integration-block"
                v-for="app in filterForCategory(category)"
                :key="app._id"
              >
                <img
                  @click="
                    $router.push({
                      name: 'integration',
                      params: {
                        id: app._id,
                      },
                    })
                  "
                  :src="app.logo_image || '../assets/placeholder-long.jpg'"
                />

                <BaseButton
                  class="connected-badge"
                  variant="primary"
                  color="v1-grey-10"
                  bold
                  size="md"
                  v-if="isConnected(app._id)"
                >
                  {{ $t("integrations_market.page.connected") }}
                </BaseButton>
              </div>
            </IQOSHorizontalScroll>
          </div>
        </div>

        <BaseDivider color="v1-grey-3" class="ml-40 mr-40" :key="`d${index}`" v-if="index != nonEmptyCategories.length-1"/>
      </template>
    </div>
  </div>
</template>

<style scoped>
/* .integrations-container::v-deep .scroller {
  height: 160px;
  width: 100%;
  gap: 16px;
  padding-right: 40px;
} */

.integration-block {
  border-radius: 8px;
  cursor: pointer;
  position: relative;
  max-width: 320px;
  max-height: 160px;
  min-width: 320px;
  width: 320px;
}

.integrations-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
}

.connected-badge {
  position: absolute;
  right: 0;
  top: 8px;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  padding: 6px 8px !important;
}

.integrations-market {
  overflow-y: auto;
  overflow-x: hidden;
  padding-top: 24px;
  padding-bottom: 40px;
}
</style>

<script>
import IntegrationsAPI from "@/api/integrations";

export default {
  data() {
    return {
      list: [],
      categories: [
        "pos_systems",
        "payment_gateways",
        "menu",
        "delivery_partners",
        "analytics"
      ],
    };
  },
  methods: {
    filterForCategory(c) {
      return this.list.filter((it) => it.category == c && it.is_published);
    },
    fetchCatalog() {
      IntegrationsAPI.getCatalog(this.$store.state.worldwide.region_code)
        .then((data) => {
          this.list = data.integrations;
        })
        .catch((err) => {});
    },
    isConnected(id) {
      return this.$store.getters["integrations/isConnected"](id);
    },
  },
  computed: {
    nonEmptyCategories() {
      return this.categories.filter((c) => {
        return this.filterForCategory(c).length > 0;
      });
    },
  },
  mounted() {
    this.fetchCatalog();
  },
};
</script>